
import { Outlet } from "react-router"

interface IProps {
    onOpenLogin: () => void
}
const LandscapeContainer = (props: IProps) : JSX.Element => { 
    return <Outlet />  
    
} 

export default LandscapeContainer